// jotai store for managing uploaded images (in-memory only)
import { atom } from "jotai";
import { atomWithStorage } from 'jotai/utils';


// Jotai atom holding uploaded images in-memory
export const imagesAtom = atom([]);


// Boolean atom, persists in localStorage under key "isUploadImagesCompleted"
export const isUploadImagesCompletedAtom = atomWithStorage(
  "isUploadImagesCompleted", // localStorage key
  false                       // default value
);



export  const showUploadModalAtom = atom(false);

